import React, { createContext, useState, useEffect, useContext } from "react";

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [languages, setLanguages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchLanguages = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BASE_URL}/get_all_languages/`,
          {
            headers: {
              accept: "application/json",
            },
          }
        );

        if (!response.ok) {
          throw new Error("Failed to fetch languages");
        }

        const data = await response.json();
        setLanguages(data);
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };

    fetchLanguages();
  }, []);

  return (
    <LanguageContext.Provider value={{ languages, loading, error }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguages = () => {
  const context = useContext(LanguageContext);
  if (context === undefined) {
    throw new Error("useLanguages must be used within a LanguageProvider");
  }
  return context;
};
